import { LayerType } from "../types/layer-type"
import { LayersDataTypes } from "../types/layers-data-types"

export interface Layer {
    id:number,
    parentId?: number,
    name: string,
    url?: string,
    label: string,
    type: number,
    dataType: number,
    opacity?: number,
    canEdit?: boolean,
    dataTypeId?: number,
    hidden: boolean,
    style3D?: {
        style: any,
        query?: string,
    } | null,
    style2D?: {
        style: any,
        query?: string,
        default?: {
            defaultLabel: string,
            defaultSymbol: any,
            type: string,
            uniqueValueInfos: Array<any>,
            valueExpression: string,
        },
        subLayers?: Array<number>,
        hover: any,
        label?: any,
        fieldName?: any
    } | null
}
export const ArcgisHybridLayer: Layer = {
    id: 0,
    name: "hybrid",
    label: "ArcGIS Imagery Hybrid",
    type: LayerType.TMS,
    dataType: LayersDataTypes.BaseMap,
    hidden: false,
    url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
}
export const ArcgisTerrainLayer: Layer = {
    id: -1,
    name: "terrain",
    label: "ArcGIS Terrain",
    type: LayerType.TMS,
    dataType: LayersDataTypes.BaseMap,
    hidden: false,
    url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}'
}

export interface ResponseLayer {
    layer: {
        id: number,
        name: string,
        label: string,
        layerTypeId: number,
        dataTypeId: number,
        parentLayerId: number | null,
        url: string | null,
        hidden: boolean
    },
    canEdit: boolean | null,
    style3D: {
        id: number,
        layerId: number,
        style: string | null,
        query: string | null
    } | null,
    style2D: {
        id: number,
        layerId: number,
        style: string | null,
        query: string | null,
        label: string | null
    } | null
}